// Bakes markup into an image: the original bitmap at its natural size with
// the items drawn on top by the SAME renderer the live overlay uses, then
// re-encoded in the original format so the file keeps its extension.

import { drawItems } from '../markupRender';
import { resolveMarkupColor, type MarkupItem } from '../markupTypes';

const JPEG_QUALITY = 0.92;

export async function exportImageWithMarkup(
  original: Blob,
  mime: string,
  items: readonly MarkupItem[],
  fileName: string,
): Promise<File> {
  const bitmap = await createImageBitmap(original);
  try {
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('canvas 2d context unavailable');
    ctx.drawImage(bitmap, 0, 0);
    drawItems(ctx, items, bitmap.width, bitmap.height, resolveMarkupColor);

    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (b) => (b ? resolve(b) : reject(new Error('canvas export produced no blob'))),
        mime,
        JPEG_QUALITY,
      );
    });
    return new File([blob], fileName, { type: mime });
  } finally {
    bitmap.close();
  }
}
